import React from 'react';
import {
  AverageChartRecordType,
  TranslatePropsType,
} from 'common/common.types';
import { withTranslation } from 'react-i18next';
import ScoreRecord from './ScoreRecord';
import { scoreScale } from './ScoreChart.styles';
import { getBarWidth } from '../utils';
import { AverageGauge } from '../Insights.styles';
import ReactHtmlParser from 'react-html-parser';

interface ScoreAveragePropsType extends TranslatePropsType {
  average: AverageChartRecordType;
}

const ScoreAverage = ({
  average: { companies, count, maximum, sum, total },
  t,
}: ScoreAveragePropsType) => {
  const hasScore = count > 0;
  const score = Math.round(sum / count);

  return (
    <AverageGauge title={t('averageCharts.validationScore')}>
      <ScoreRecord
        color={scoreScale(score).hex()}
        name={t('averageScoreName', { count: total })}
        title={t('averageScoreTitle', { count: companies.size })}
        width={getBarWidth(maximum, score, 90)}
      >
        {hasScore
          ? ReactHtmlParser(t('percentage', { count: score }))
          : (t('na') as string)}
      </ScoreRecord>
    </AverageGauge>
  );
};

export default withTranslation('Insights')(ScoreAverage);
